const verification = {
    title: 'Пройдите верификацию компании',
    description:
        'Ваша компания должна быть <b>верифицирована</b> системой. Фунционал CRM-системы будет ограничен: <b>нельзя</b> совершать выплаты, управлять договорами и массовыми подключениями',
    buttonText: 'Пройти верификацию сейчас',
} as const;

export default verification;
